import React from 'react';
import { Button, SparkIcon } from '@spark';
import { handleCopy } from '@/shared/utils/helpers';
import { downloadTextFile } from '@/shared/utils/downloadTextFile';

/**
 * Copy + Download icon buttons for code snippets.
 *
 * Uses Spark icon-only Button tooltips (do not wrap these in TooltipTrigger —
 * that stacks a second tooltip on hover).
 */
const CodeSnippetActions = ({
    code,
    filename,
    variant = 'ghost',
    showDownload = true,
    disabled = false,
}) => {
    const canAct = Boolean(code) && !disabled;

    return (
        <>
            <Button
                variant={variant}
                size="small"
                type="button"
                disabled={!canAct}
                aria-label="Copy"
                tooltip="Copy"
                icon={<SparkIcon slug="copy" size="small" />}
                iconSlug="copy"
                onClick={() => handleCopy(code)}
            />
            {showDownload ? (
                <Button
                    variant={variant}
                    size="small"
                    type="button"
                    disabled={!canAct}
                    aria-label="Download"
                    tooltip="Download"
                    icon={<SparkIcon slug="download" size="small" />}
                    iconSlug="download"
                    onClick={() => downloadTextFile(code, filename)}
                />
            ) : null}
        </>
    );
};

export default CodeSnippetActions;
